/** Skeleton loading placeholder: a pulsing bar standing in for text or a block. */

export interface SkeletonProps {
  /** CSS width, e.g. `"60%"` or `"12rem"`. Defaults to `"100%"`. */
  width?: string;
  /** CSS height. Defaults to `"1em"`. */
  height?: string;
}

/**
 * Render a single pulsing skeleton bar.
 *
 * @param props - Optional width and height overrides.
 * @returns The skeleton element.
 */
export function Skeleton({ width = '100%', height = '1em' }: SkeletonProps) {
  return (
    <span
      className="ui-skeleton"
      style={{ width, height }}
      role="presentation"
      aria-hidden="true"
    />
  );
}
